import * as React from "react";
import { Stack } from "@mui/material";
import { generateSide } from "../../../../lib/generateSide";
import { IXCategoryFilterProps } from "../../../../utils/interfaces/containers/XCategoryFilter.interfaces";
import { TSetUrlParamsArgs } from "../../../../hooks/useXoraia";
import FilterSection from "./FilterSection";
import CategoryFilter from "./CategoryFilter";
import PricingFilter from "../../XGrid/PricingFilter";
import BadgesFilter from "./BadgesFilter";
import OtherOptionsFilter from "./OtherOptionsFilter";

const FilterSide: React.FC<
  IXCategoryFilterProps & {
    onChange: (args: TSetUrlParamsArgs) => Promise<void>;

    urlParams: TSetUrlParamsArgs;
  }
> = (props) => {
  const {
    filterBgColor,
    filterWidth = "300px",
    filterPadding,
    sectionGap = "20px",
    divider = false,
    // TITLE
    titleFontSize = "18px",
    titleFontWeight = 500,
    titleFontStyle = "normal",
    titleColor = "#000000",
    titleBgColor,
    titleHeight = "50px",

    // GRID

    // pageLimit = 5, // TODO IMPLEMENT PAGE LIMITE

    // CHECK BOX
    checkboxSize = "20px",
    checkboxTextColor,
    checkboxColor,
  } = props;

  return (
    <Stack
      spacing={sectionGap}
      bgcolor={filterBgColor}
      width={filterWidth}
      sx={{
        padding: generateSide("padding", filterPadding),
        "&.XCategoryFilter_Filter": {
          position: "sticky",
          top: 0,
          left: 0,

          "& .XCategoryFilter_FilterSection": {
            bgcolor: "transparent",
            mt: 0,
            borderRadius: 0,
            border: 0,
            lineHeight: "1em",
            borderBottom: divider ? 3 : 0,
            borderBottomColor: "#cdcdcd",

            "&:not(last-of-type)": {
              borderBottom: 0,
            },

            "&:before": {
              display: "none",
            },

            "&.Mui-expanded": {
              pb: 2,
            },

            "& .MuiPaper-root": {
              bgcolor: "transparent",
            },

            "& .MuiAccordionSummary-root": {
              px: 0,
              alignItems: "center",
              minHeight: "auto",
              bgcolor: "transparent",

              "& .MuiAccordionSummary-content": {
                mt: 0,
                mb: 0,
                height: titleHeight,
                alignItems: "center",
                bgcolor: titleBgColor ?? "transparent",

                // "&:hover": {
                //   color: primaryColor,
                // },

                "& .XCategoryFilter_FilterSection_Title": {
                  fontSize: titleFontSize,
                  fontWeight: titleFontWeight,
                  fontStyle: titleFontStyle,
                  color: titleColor,
                  lineHeight: "1em",
                  fontFamily: "inherit",
                  width: "100%",
                },
              },
            },

            "& .MuiCollapse-root": {
              // borderLeft: '1px solid #eee',

              "& .MuiAccordionDetails-root": {
                p: 0,

                "& .MuiListItemText-root": {
                  m: 0,
                  "& span": { lineHeight: "1em" },
                },

                // CHECKBOX FILTER
                "& .MuiFormGroup-root": {
                  // CHECKBOX
                  "& .MuiCheckbox-root": {
                    "&.Mui-checked": {
                      color: checkboxColor,
                      // color: checkboxActiveColor,
                    },

                    "& .MuiSvgIcon-root": {
                      fontSize: checkboxSize,
                    },
                  },
                  // LABEL
                  "& .MuiFormControlLabel-root": {
                    color: checkboxTextColor,

                    "& .MuiTypography-root": {
                      color: "inherit",

                      "&:not(.MuiTypography-caption)": {
                        fontSize: "inherit",
                      },
                    },
                  },
                },
              },
            },
          },
        },
      }}
      className="XCategoryFilter_Filter"
    >
      <FilterSection title="Catégories" child={<CategoryFilter {...props} />} />
      <FilterSection title="Prix" child={<PricingFilter {...props} />} />
      <FilterSection title="Badges" child={<BadgesFilter {...props} />} />
      <OtherOptionsFilter {...props} />
    </Stack>
  );
};

export default FilterSide;
